import Repository from "@/services/Repository";

export default {
  getCorp(id) {
    return Repository.get(`/latest/corporations/${id}/`);
  },
  getLoyaltyStore(id) {
    return Repository.get(`/latest/loyalty/stores/${id}/offers/`);
  }
};
